/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Upgrade_Modal_CompareInputs */

const en_upgrade_modal_compare = /** @type {(inputs: Upgrade_Modal_CompareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compare Plans`)
};

const es_upgrade_modal_compare = /** @type {(inputs: Upgrade_Modal_CompareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparar Planes`)
};

const fr_upgrade_modal_compare = /** @type {(inputs: Upgrade_Modal_CompareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparer les forfaits`)
};

const de_upgrade_modal_compare = /** @type {(inputs: Upgrade_Modal_CompareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pläne vergleichen`)
};

const id_upgrade_modal_compare = /** @type {(inputs: Upgrade_Modal_CompareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bandingkan Paket`)
};

/** @type {(inputs: Upgrade_Modal_CompareInputs) => LocalizedString} */
const ja_upgrade_modal_compare = en_upgrade_modal_compare;

/** @type {(inputs: Upgrade_Modal_CompareInputs) => LocalizedString} */
const zh_upgrade_modal_compare = en_upgrade_modal_compare;

/** @type {(inputs: Upgrade_Modal_CompareInputs) => LocalizedString} */
const ar_upgrade_modal_compare = en_upgrade_modal_compare;

/** @type {(inputs: Upgrade_Modal_CompareInputs) => LocalizedString} */
const it_upgrade_modal_compare = en_upgrade_modal_compare;

/** @type {(inputs: Upgrade_Modal_CompareInputs) => LocalizedString} */
const ru_upgrade_modal_compare = en_upgrade_modal_compare;

/** @type {(inputs: Upgrade_Modal_CompareInputs) => LocalizedString} */
const pt_upgrade_modal_compare = en_upgrade_modal_compare;

/** @type {(inputs: Upgrade_Modal_CompareInputs) => LocalizedString} */
const ko_upgrade_modal_compare = en_upgrade_modal_compare;

/**
* | output |
* | --- |
* | "Compare Plans" |
*
* @param {Upgrade_Modal_CompareInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const upgrade_modal_compare = /** @type {((inputs?: Upgrade_Modal_CompareInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Upgrade_Modal_CompareInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_upgrade_modal_compare(inputs)
	if (locale === "es") return es_upgrade_modal_compare(inputs)
	if (locale === "fr") return fr_upgrade_modal_compare(inputs)
	if (locale === "de") return de_upgrade_modal_compare(inputs)
	if (locale === "ja") return ja_upgrade_modal_compare(inputs)
	if (locale === "zh") return zh_upgrade_modal_compare(inputs)
	if (locale === "ar") return ar_upgrade_modal_compare(inputs)
	if (locale === "id") return id_upgrade_modal_compare(inputs)
	if (locale === "it") return it_upgrade_modal_compare(inputs)
	if (locale === "ru") return ru_upgrade_modal_compare(inputs)
	if (locale === "pt") return pt_upgrade_modal_compare(inputs)
	return ko_upgrade_modal_compare(inputs)
});